import { render } from "./StudentIdCards.vue?vue&type=template&id=c359f584&scoped=true"
import script from "./StudentIdCards.vue?vue&type=script&lang=js"
export * from "./StudentIdCards.vue?vue&type=script&lang=js"

import "./StudentIdCards.vue?vue&type=style&index=0&id=c359f584&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c359f584"]])

export default __exports__